import type { FC } from 'react'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  needsReview: boolean
  reopened: boolean
}

export const DEFAULT_FILTER: Filter = {
  needsReview: true,
  reopened: true,
}

interface Props {
  filter: Filter
  onChangeFilter: (sectionFilters: Filter) => void
}

const SectionFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <>
    <Checkbox
      label="Needs manual review"
      checked={filter.needsReview}
      onChange={e =>
        onChangeFilter({
          ...filter,
          needsReview: e.target.checked,
        })
      }
    />
    <Checkbox
      label="Reopened"
      checked={filter.reopened}
      onChange={e =>
        onChangeFilter({
          ...filter,
          reopened: e.target.checked,
        })
      }
    />
  </>
)

export default SectionFilter
